<template>
  <section id="hero" class="nuxt-hero">
    <!-- Full-size background image -->
    <div class="hero-bg">
      <div class="hero-bg-img"></div>
      <div class="hero-overlay"></div>
      <div class="hero-vignette"></div>
    </div>

    <div class="hero-container">
      <div class="hero-grid">
        <!-- Left: Text Content -->
        <div class="hero-text">
          <!-- Badge -->
          <a href="#" class="hero-badge">
            <span class="badge-dot"></span>
            <span>Platform Layanan Rumah #1 Indonesia</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </a>

          <!-- Title -->
          <h1 class="hero-title">
            <span class="title-white">Solusi Terbaik.</span>
            <span class="title-gradient">Keseharian Anda.</span>
          </h1>

          <!-- Subtitle -->
          <p class="hero-subtitle">
            Temukan solusi untuk kerusakan rumah, perbaikan elektronik,
            dan layanan darurat dalam satu aplikasi.
          </p>

          <!-- CTA Buttons -->
          <div class="hero-actions">
            <router-link to="/gabungmitra" class="btn-primary">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <line x1="19" y1="8" x2="19" y2="14"/>
                <line x1="22" y1="11" x2="16" y2="11"/>
              </svg>
              Gabung Mitra Yohom
            </router-link>
            <a
              href="https://wa.me/6282228502424?&text=Hai Yohom, Saya mau melakukan pemesanan jasa. Bisakah anda membantu?"
              target="_blank"
              class="btn-secondary"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Pesan Sekarang
            </a>
          </div>

          <!-- Stats Row -->
          <div class="hero-stats">
            <div class="stat-item">
              <span class="stat-number">500+</span>
              <span class="stat-label">Mitra Aktif</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-number">10K+</span>
              <span class="stat-label">Pesanan Selesai</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-number">4.8</span>
              <span class="stat-label">Rating</span>
            </div>
          </div>
        </div>

        <!-- Right: Phone Visual -->
        <div class="hero-visual">
          <div class="phone-wrapper">
            <div class="phone-glow"></div>
            <img
              src="assets/img/hero-phone.png"
              class="phone-img"
              alt="Yohom App"
            />
            <!-- Floating cards around the phone -->
            <div class="float-card float-card--1">
              <div class="float-icon float-icon--green">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <div class="float-text">
                <span class="float-title">Garansi Aktif</span>
                <span class="float-sub">Semua layanan</span>
              </div>
            </div>
            <div class="float-card float-card--2">
              <div class="float-icon float-icon--blue">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div class="float-text">
                <span class="float-title">30 Menit</span>
                <span class="float-sub">Estimasi tiba</span>
              </div>
            </div>
            <div class="float-card float-card--3">
              <div class="float-icon float-icon--amber">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              <div class="float-text">
                <span class="float-title">Rating 4.8</span>
                <span class="float-sub">1200+ review</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700;800;900&display=swap');

.nuxt-hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  font-family: 'Public Sans', sans-serif;
  overflow: hidden;
  overflow-x: hidden;
  padding: 100px 24px 60px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  box-sizing: border-box;
}

/* ============================
   Full-size Background Image
   ============================ */
.hero-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.hero-bg-img {
  position: absolute;
  inset: 0;
  background: url('/assets/img/background.jpg') center center / cover no-repeat;
}

/* Dark overlay for text readability */
.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(5, 10, 20, 0.88) 0%,
    rgba(5, 10, 20, 0.75) 50%,
    rgba(5, 10, 20, 0.65) 100%
  );
}

.hero-vignette {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse at 20% 50%, rgba(16, 185, 129, 0.08) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 80%, rgba(34, 197, 94, 0.05) 0%, transparent 50%);
}

/* ============================
   Layout
   ============================ */
.hero-container {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

/* ============================
   Text Content
   ============================ */
.hero-text {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Badge */
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px 6px 12px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
  width: fit-content;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.hero-badge:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.9);
}

.badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.6);
  animation: dotPulse 2s ease-in-out infinite;
}

@keyframes dotPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.hero-badge svg {
  opacity: 0.4;
}

/* Title */
.hero-title {
  margin: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.05;
}

.title-white {
  font-size: 60px;
  font-weight: 900;
  letter-spacing: -0.04em;
  color: rgba(255, 255, 255, 0.92);
}

.title-gradient {
  font-size: 60px;
  font-weight: 900;
  letter-spacing: -0.04em;
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 50%, #16a34a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Subtitle */
.hero-subtitle {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.7;
  max-width: 440px;
  margin: 0;
}

/* Buttons */
.hero-actions {
  display: flex;
  gap: 12px;
  padding-top: 4px;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 13px 26px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Public Sans', sans-serif;
  color: #0b0f19;
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
  border: none;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 0 24px rgba(34, 197, 94, 0.2);
}

.btn-primary:hover {
  box-shadow: 0 0 36px rgba(34, 197, 94, 0.35);
  transform: translateY(-2px);
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 13px 26px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Public Sans', sans-serif;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.22);
  color: #ffffff;
  transform: translateY(-2px);
}

.btn-secondary svg {
  color: #25d366;
}

/* Stats */
.hero-stats {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-top: 8px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-number {
  font-size: 24px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: -0.02em;
}

.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.35);
  font-weight: 500;
}

.stat-divider {
  width: 1px;
  height: 36px;
  background: rgba(255, 255, 255, 0.1);
}

/* ============================
   Phone Visual
   ============================ */
.hero-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 100%;
}

.phone-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(34, 197, 94, 0.15) 0%, transparent 70%);
  filter: blur(60px);
}

.phone-img {
  position: relative;
  max-height: 520px;
  width: auto;
  filter: drop-shadow(0 24px 48px rgba(0, 0, 0, 0.4));
  animation: phoneFloat 6s ease-in-out infinite;
}

@keyframes phoneFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
}

/* ============================
   Floating Cards
   ============================ */
.float-card {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  animation: cardFloat 5s ease-in-out infinite;
  z-index: 2;
}

.float-card--1 {
  top: 12%;
  right: -10px;
  animation-delay: 0s;
}

.float-card--2 {
  bottom: 25%;
  left: -20px;
  animation-delay: 1.5s;
}

.float-card--3 {
  bottom: 8%;
  right: 5%;
  animation-delay: 3s;
}

@keyframes cardFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.float-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
}

.float-icon--green {
  background: rgba(34, 197, 94, 0.2);
  color: #4ade80;
}

.float-icon--blue {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}

.float-icon--amber {
  background: rgba(245, 158, 11, 0.2);
  color: #fbbf24;
}

.float-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.float-title {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

.float-sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
}

/* ============================
   Responsive — Tablet
   ============================ */
@media (max-width: 968px) {
  .nuxt-hero {
    padding: 80px 20px 48px;
    min-height: auto;
    overflow-x: hidden;
  }

  .hero-grid {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 32px;
  }

  .hero-text {
    align-items: center;
    order: 2;
  }

  .hero-visual {
    order: 1;
  }

  .hero-badge span {
    font-size: 12px;
  }

  .title-white,
  .title-gradient {
    font-size: 40px;
  }

  .hero-subtitle {
    max-width: 480px;
    font-size: 16px;
  }

  .hero-actions {
    justify-content: center;
    flex-wrap: wrap;
  }

  .hero-stats {
    justify-content: center;
  }

  .phone-wrapper {
    max-width: 280px;
  }

  .phone-img {
    max-height: 340px;
    max-width: 100%;
  }

  .phone-glow {
    width: 220px;
    height: 220px;
  }

  .float-card {
    display: none;
  }
}

/* ============================
   Responsive — Mobile
   ============================ */
@media (max-width: 640px) {
  .nuxt-hero {
    padding: 76px 16px 36px;
  }

  .hero-grid {
    gap: 24px;
  }

  .hero-text {
    gap: 16px;
  }

  .title-white,
  .title-gradient {
    font-size: 32px;
  }

  .hero-subtitle {
    font-size: 15px;
    max-width: 100%;
  }

  .hero-actions {
    flex-direction: column;
    width: 100%;
    align-items: stretch;
  }

  .btn-primary,
  .btn-secondary {
    justify-content: center;
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
    box-sizing: border-box;
  }

  .hero-stats {
    gap: 16px;
  }

  .stat-number {
    font-size: 20px;
  }

  .stat-label {
    font-size: 11px;
  }

  .stat-divider {
    height: 28px;
  }

  .phone-wrapper {
    max-width: 220px;
  }

  .phone-img {
    max-height: 280px;
  }

  .float-card {
    display: none;
  }
}

/* ============================
   Responsive — Small phones
   ============================ */
@media (max-width: 380px) {
  .title-white,
  .title-gradient {
    font-size: 28px;
  }

  .hero-badge {
    padding: 5px 12px 5px 10px;
    font-size: 11px;
  }

  .hero-badge span {
    font-size: 11px;
  }

  .hero-subtitle {
    font-size: 14px;
  }

  .phone-wrapper {
    max-width: 180px;
  }

  .phone-img {
    max-height: 230px;
  }
}
</style>